var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5 14c1.396 0 2.571.957 2.905 2.25H20v1.5H7.905A3.005 3.005 0 0 1 5 20a3.005 3.005 0 0 1-2.905-2.25H0v-1.5h2.095A3.005 3.005 0 0 1 5 14zm0 1.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM17 7c1.396 0 2.571.957 2.905 2.25H20v1.5h-.095A3.005 3.005 0 0 1 17 13a3.005 3.005 0 0 1-2.905-2.25H0v-1.5h14.095A3.005 3.005 0 0 1 17 7zm0 1.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM9 0c1.396 0 2.571.957 2.905 2.25H20v1.5h-8.095A3.005 3.005 0 0 1 9 6a3.005 3.005 0 0 1-2.905-2.25H0v-1.5h6.095A3.005 3.005 0 0 1 9 0zm0 1.75c-.69 0-1.25.56-1.25 1.25S8.31 4.25 9 4.25s1.25-.56 1.25-1.25S9.69 1.75 9 1.75z",
    id: "vlc8y97iea"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b5nw72ltob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vlc8y97iea"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#vlc8y97iea"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b5nw72ltob)",
    fill: "#33AE33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.2896613d970e1248be9f8e57d49bbb0b.svg";
export { ForwardRef as ReactComponent };